import React, { useEffect, useContext, useState, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  customStyle
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { useCustomHooks } from "../../../../../functions/Hooks";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import StockReport from "./StockReport";
//pages & includes
import ManageSidebar from "../ManageSidebar";
import ItemMultiSelectModalForItem from "../../../../components/Common/ItemMultiSelectModalForItem";

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import { FoodContext } from "../../../../../contexts/Food";

const FgRequisitionAction = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const {id} = useParams();
    const { roundOffStock, qtyAmountPoints } = useCustomHooks();
    //getting context values here
    let {
      loading,
      setLoading,
      branchForSearch,
      branchListWeb,
    } = useContext(RestaurantContext);
    let { foodForPOS } = useContext(FoodContext)

    //row id
    let rowId=useRef(0);
    let {
      //opening stock
      setStoreRequisitionList,
      setStoreRequisitionForSearch,
      authUserInfo
    } = useContext(UserContext);

    // States hook here
    //new item
    let [newFgRequisition, setNewFgRequisition] = useState({
      document_no: "",
      fbranch: null,
      tbranch: null,      
      remarks: "",
    });
    //new Row
    const [newRow,setNewRow]=useState([]);
    
    //datepicker
    const [documentDate, setDocumentDate] = useState(new Date());

    // Multi select modal
    const [showMultiSelectModal, setShowMultiSelectModal] = useState(false);

    const openMultiSelectModal = () => {
      if (newFgRequisition.fbranch !== null && newFgRequisition.tbranch !== null) {
        setShowMultiSelectModal(true);
      } else {
        toast.error(`${_t(t("Please select both branches"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    };

    //Get Specific item for edit
    const getOpeningStockItem = async () => {
      setLoading(true);
      const url = BASE_URL + "/settings/finished-good-requisition/" + parseInt(id);
      try {
        const res = await axios
        .get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
          if(res){
            hanldeSetEdit(res.data)
          }
          setLoading(false);
      } catch {
        setLoading(false);
      }
    };
  
    const [branchSearch, setBranchSearch] = useState(null);

    useEffect(()=>{
      if (authUserInfo?.details.user_type === "manager" || authUserInfo?.details.user_type === "staff") {
        setBranchSearch(
          branchForSearch.filter((branch) => branch.id === authUserInfo.details.branch_id)
        );
      } else {
        setBranchSearch(branchForSearch);
      }
    },[]);

    const hanldeSetEdit = (editStore) =>{
      if(editStore && editStore?.length){
        console.log(editStore, 'editStore');
        
        let docDate= new Date(editStore[0].document_date);

        setNewFgRequisition({
          ...newFgRequisition,
          is_post: editStore[0].is_post,
          document_no: editStore[0].document_identity,
          fbranch: editStore[0].from_branch,
          tbranch: editStore[0].to_branch,
          remarks: editStore[0].remarks,
        })
        setDocumentDate(docDate);
        let rowArr=[];
        if(editStore[0].finishedgooddetail && editStore[0].finishedgooddetail.length > 0){
          editStore[0].finishedgooddetail.map((item)=>{
            rowArr.push({
              id: rowId.current,
              item_name:{
                ...item,
                id: item.item_id,
                name: item.item_name
              },
              qty: roundOffStock(item.qty),
              isEdit: true
            })
            rowId.current += 1
          })
          setNewRow([...rowArr]);
        }
      }
    }

    useEffect(()=>{
      id && getOpeningStockItem();
    },[id])

    //set items hook
    const handleSetItems = async (index,item) => {
      newRow[index].item_name=item;
      newRow[index].qty="";
      setNewRow([...newRow]);
    };

    const addNewRow=()=>{  
      if (newFgRequisition.fbranch !== null && newFgRequisition.tbranch !== null) {
        let newID=rowId.current     
        setNewRow((pre)=>[...pre,{
          id:newID,
          item_name:"",
          qty:"",
          isEdit:false,
        }])
        rowId.current = rowId.current + 1;
      } else {
        toast.error(`${_t(t("Please select both branches"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    }
  
    const delRow=(id)=>{
      let row=[...newRow]
      row= row.filter((item,i)=>id!==item.id);
      setNewRow(row);
    }

    const handleAddMultipleItems = (items) => {
      let currentId = rowId.current;
      const newRowsToAdd = items.map((item) => {
        const row = {
          id: currentId,
          item_name: item,
          qty: "",
          isEdit: false,
        };
        currentId++;
        return row;
      });
      
      setNewRow((pre) => [...pre, ...newRowsToAdd]);
      rowId.current = currentId;
    };
  
    //set each item qty
    const handleItemQty = (index,e) => {
      newRow[index].qty=e.target.value;
      setNewRow([...newRow]);
    };

    //handle Set branch hook
    const handleSetBranch = (fbranch) => {
      newFgRequisition.tbranch = null;
      setNewFgRequisition({ ...newFgRequisition, fbranch });
    };

    const handleSetToBranch = (tbranch) => {
      setNewFgRequisition({ ...newFgRequisition, tbranch });
    };

    const handleRemarks=(e)=>{
      setNewFgRequisition({ ...newFgRequisition, remarks:e.target.value });
    }
  
    //post req of stock item update
    const storeItemsAxios = async () => {
      let date =
        new Date(documentDate).getFullYear() +
        "-" +
        (new Date(documentDate).getMonth() + 1) +
        "-" +
        new Date(documentDate).getDate();

      let slugArray=[];
      let duplicate = {};
      const duplicateItem = [];
      newRow.map((newStockItem) => {
        if(duplicate[newStockItem.item_name.id]){
          duplicateItem.push({
            item_id: newStockItem.item_name.id,
            item_name: newStockItem.item_name.name,  
          })
        }
        if(newStockItem.item_name === ""){
          toast.error(`${_t(t("Please select all dropdowns"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        }else{
          duplicate[newStockItem.item_name.id] = true;
          slugArray.push({
            qty: parseFloat(newStockItem.qty),
            item_id: newStockItem.item_name.id,
            item_name: newStockItem.item_name.name,          
          });
        }
      });

      if(duplicateItem?.length){
        toast.error(`${_t(t(`Duplicate item ${duplicateItem[0].item_name} found`))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        return;
      }
        
      if(newRow.length === slugArray.length){
        setLoading(true);
        let formData = {
          id: id,
          from_branch_id: newFgRequisition.fbranch.id, 
          to_branch_id: newFgRequisition.tbranch.id,    
          document_date: date,
          remarks: newFgRequisition.remarks,
          items: slugArray,
        };
        const endpoint = id ? "/settings/finished-good-requisition/" + parseInt(id) : "/settings/finished-good-requisition";
        const url = BASE_URL + endpoint;
        const method = id ? "put" : "post";
        try {
          const res = await axios[method](url, formData, {
            headers: { Authorization: `Bearer ${getCookie()}` },
          });
          // setStoreRequisitionList(res.data[0]);
          // setStoreRequisitionForSearch(res.data[1]);
          setLoading(false);
          toast.success(`${_t(t("Fg Requisition has been updated"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          history.push("/dashboard/manage/stock/fg-requisition")
        } catch (error) {
          console.log("check error==>",error);
          setLoading(false);
          if(error.response.data.status === 0){
            toast.error(<span className="text-preline">{error.response.data.message}</span>, {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            });
            return
          }
          toast.error(`${_t(t("Please try again later"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        }
      }
    };
  
    //send to server
    const handleSubmit = (e) => {
      e.preventDefault();
      if (
        newFgRequisition.fbranch !== null &&
        newFgRequisition.fbranch !== null &&
        newFgRequisition.document_no !== null &&
        documentDate !== null
      ) {
        if(newRow.length > 0){
          storeItemsAxios();
        } else{
          toast.error(`${_t(t("Please add items"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        }
      } else {
        toast.error(`${_t(t("Please fill all the required fields"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    };
  
    return (
      <>
        <Helmet>
          <title>{_t(t("Edit Finish Goods Requisition"))}</title>
        </Helmet>
  
        {/* main body */}
        <main id="main" data-simplebar>
          <div className="container-fluid">
            <div className="row t-mt-10 gx-2">
              {/* left Sidebar */}
              <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
                <ManageSidebar />
              </div>
              {/* left Sidebar ends */}
  
              {/* Rightbar contents */}
              <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
                <div className="t-bg-white">
                  <div
                    className="fk-scroll--pos-menu table-bottom-info-hide"
                    data-simplebar
                  >
                    <div className="t-pl-15 t-pr-15">
                      {/* next page data spin loading */}
                      {/* <div className={`${dataPaginating && "loading"}`}></div> */}
                      {/* spin loading ends */}
  
                      {/* Loading effect */}
                      {loading === true ? (
                        tableLoading()
                      ) : (
                        <div key="smtp-form">
                          <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                            <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                              <ul className="t-list fk-breadcrumb">
                                <li className="fk-breadcrumb__list">
                                  <span className="t-link fk-breadcrumb__link text-capitalize">
                                    {id ? 
                                    _t(t("Edit Finish Goods Requisition")) :
                                    _t(t("Add Finish Goods Requisition")) }
                                  </span>
                                </li>
                              </ul>
                            </div>
                            <div className="col-md-6 col-lg-7">
                              <div className="row gx-3 align-items-center"></div>
                            </div>
                          </div>
  
                          {/* Form starts here */}
                          <form
                            className="row card p-2 mx-3 mb-5 table-text"
                            onSubmit={handleSubmit}
                            autoComplete="off"
                          >
                            <div className="col-12">
                              <div className="row">
                                <div className="form-group col-4 mt-3">
                                  <div className="mb-2">
                                    <label
                                      htmlFor="document no"
                                      className="control-label"
                                    >
                                      {_t(t("Document no"))}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div className="mb-2">
                                    <input
                                      readOnly
                                      type="text"
                                      className="form-control table-text"
                                      id="document_no"
                                      name="document_no"                                      
                                      value={newFgRequisition.document_no}
                                      placeholder="Auto no"
                                      required
                                    />
                                  </div>
                                </div>
  
                                <div className="form-group col-4 text-right mt-3">
                                  <div className="mb-2 text-left">
                                    <label
                                      htmlFor="transfer_date"
                                      className="control-label"
                                    >
                                      {_t(t("Document Date"))}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div className="mb-2">
                                    <DatePicker
                                      selected={documentDate}
                                      onChange={(date) => setDocumentDate(date)}
                                      peekNextMonth
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      className="form-control table-text"
                                      placeholderText={_t(t("Document date"))}
                                      shouldCloseOnSelect={false}
                                      disabled={id}
                                    />
                                  </div>
                                </div>
                                  
                                <div className="form-group mt-3 col-4">
                                    <div className="mb-2">
                                      <label
                                        htmlFor="branch"
                                        className="control-label"
                                      >
                                        {_t(t("From Branch"))}
                                        <span className="text-danger">*</span>                                        
                                      </label>
                                    </div>
                                    <Select
                                      options={branchSearch}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      value={newFgRequisition.fbranch || null}
                                      classNamePrefix="select"
                                      onChange={handleSetBranch}
                                      maxMenuHeight="200px"
                                      styles={customStyle}
                                      placeholder={
                                        _t(t("Please from branch")) + ".."
                                      }
                                      isDisabled={id}
                                    />
                                </div> 
                              </div>
  
                              <div className="row"> 
                                <div className="form-group mt-2 col-4">
                                  <div className="mb-2">
                                    <label
                                      htmlFor="branch"
                                      className="control-label"
                                    >
                                      {_t(t("To Branch"))}
                                      <span className="text-danger">*</span>                                        
                                    </label>
                                  </div>
                                  <Select
                                    options={branchListWeb ? branchListWeb.filter((item)=>item.id!==newFgRequisition?.fbranch?.id) : []}
                                    components={makeAnimated()}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    value={newFgRequisition.tbranch || null}
                                    classNamePrefix="select"
                                    onChange={handleSetToBranch}
                                    maxMenuHeight="200px"
                                    styles={customStyle}
                                    placeholder={
                                      _t(t("Please to branch")) + ".."
                                    }
                                    isDisabled={id}
                                  />
                                </div>                                                            
                                <div className="form-group mt-2 col-8">
                                  <div className="mb-2">
                                    <label
                                      htmlFor="remarks"
                                      className="control-label"
                                    >
                                      {_t(t("Remarks"))}
                                    </label>
                                  </div>
                                  <div className="mb-2">
                                    <textarea
                                      type="text"
                                      className="form-control table-text"
                                      id="remarks"
                                      name="remarks"
                                      onChange={handleRemarks}
                                      value={newFgRequisition.remarks || ""}
                                      placeholder="Remarks"
                                      style={{height:"33px"}}
                                      disabled={newFgRequisition?.is_post}
                                    />
                                  </div>
                                </div>
                              </div>

                              {!newFgRequisition?.is_post && (
                                <div className="d-flex justify-content-end mb-2">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary shadow-sm"
                                    style={{ borderRadius: '6px' }}
                                    onClick={openMultiSelectModal}
                                  >
                                    <i className="fa fa-tasks mr-1"></i> {_t(t("Add Multiple Items"))}
                                  </button>
                                </div>
                              )}                            
                              
                              {!newFgRequisition?.is_post && (
                                <div className="d-flex justify-content-end mb-2">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary shadow-sm"
                                    style={{ borderRadius: '6px' }}
                                    onClick={openMultiSelectModal}
                                  >
                                    <i className="fa fa-tasks mr-1"></i> {_t(t("Add Multiple Items"))}
                                  </button>
                                </div>
                              )}

                              <div className={`table-responsive mt-3 pr-1 `}
                                style={{maxHeight:"23rem",overflow: "auto"}}>
                                  <table className="table table-bordered-sm table-hover">
                                    <thead className="align-middle">                                    
                                      <tr>
                                      {(newRow.length==0 ?
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                        >
                                        <span className="t-mr-10" onClick={()=>addNewRow()}>
                                          <i className="fa fa-plus-circle cursor-pointer btn-add-icon" style={{fontSize:"22px"}} aria-hidden="true" title={t("Add Single Item")}></i>
                                        </span>
                                        </th>
                                        : !newFgRequisition?.is_post ? <th style={{borderBottomColor:"lightgray"}}></th> : null)}
                                        <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border table_child"
                                        >
                                          <span style={{fontWeight:500}}>
                                          {_t(t("Item Name"))}
                                          </span>
                                        </th>                                     
                                        
                                        <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                        >
                                          <span style={{fontWeight:500}}>
                                          {_t(t("Qty"))}
                                          </span>
                                        </th>
                                      
                                      </tr>
                                    </thead>
                                      {newRow && newRow.length>0 ?
                                        <tbody className="align-middle">
                                          {newRow.map(
                                            (item, index) => {
                                              return (
                                                <tr
                                                  className="align-middle"
                                                  key={index}
                                                >
                                                  { !newFgRequisition?.is_post  ? <td className="table-text text-capitalize align-middle text-center table-firstChild" style={{minWidth:"60px"}}>
                                                  {index==(newRow.length-1) && <>
                                                  <span className="t-mr-10" onClick={()=>addNewRow()}>
                                                    <i className="fa fa-plus-circle btn-add-icon cursor-pointer" style={{fontSize:"22px"}} aria-hidden="true" title={t("Add Single Item")}></i>
                                                  </span>
                                                  </>}&nbsp;
                                                  <i className="fa fa-minus-circle cursor-pointer text-danger" style={{fontSize:"22px"}} 
                                                  onClick={()=>{delRow(item.id)}}
                                                  ></i>
                                                  </td> : null}
                                                  <td className="table-text text-capitalize align-middle text-center">                                                
                                                    <Select
                                                      options={foodForPOS !== null ? foodForPOS : []}
                                                      components={makeAnimated()}
                                                      getOptionLabel={(option) => option.name}
                                                      getOptionValue={(option) => option.id}
                                                      classNamePrefix="select"
                                                      onChange={(e)=>handleSetItems(index,e)}
                                                      maxMenuHeight="12.8rem"
                                                      // menuPlacement="top"
                                                      value={item.item_name}
                                                      styles={customStyle}
                                                      isMenuOpen={true}
                                                      menuPosition="fixed"
                                                      className="bank-table-input"
                                                      isDisabled={newFgRequisition?.isEdit || newFgRequisition?.is_post}
                                                      placeholder={
                                                      _t(t("Please select items")) + ".."
                                                      }                                                
                                                    />
                                                  </td>                                              

                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    <input
                                                      type="number"
                                                      step={qtyAmountPoints()}
                                                      min="0"
                                                      onKeyDown={(evt) =>
                                                        ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                                        evt.preventDefault()
                                                      }
                                                      onWheel={(e) => e.target.blur()}
                                                      className="form-control text-center table-Input table-text"
                                                      id={item.id}
                                                      name={item.id}
                                                      onChange={(e)=>handleItemQty(index,e)}
                                                      value={                                                    
                                                        item.qty || ""
                                                      }
                                                      placeholder="Qty"
                                                      required
                                                      disabled={newFgRequisition?.isEdit || newFgRequisition?.is_post}                                                  
                                                    />
                                                  </td>

                                                </tr>
                                              );
                                            }
                                          )}
                                        </tbody>
                                      : null}
                                  </table>
                              </div>
                                
  
                              <div className="d-flex justify-content-end align-items-center">
                                <div className="col-3 d-flex justify-content-end">
                                  <button
                                  type="button"
                                  className="btn rounded hov-btn mr-3"
                                  onClick={()=>(history.push("/dashboard/manage/stock/fg-requisition"))}
                                  >
                                    <i class="fa fa-arrow-left" aria-hidden="true"></i> {_t(t("Back"))}
                                  </button>
                                  {
                                    !newFgRequisition?.is_post ? (
                                      <button
                                      disabled={loading}
                                      type="submit"
                                      className="btn btn-primary rounded"
                                    >
                                      <i class="fa fa-floppy-o" aria-hidden="true"></i> {_t(t("Save"))}
                                    </button>  ) : (
                                      <></>
                                    )
                                  }
                                </div>                                                    
                              </div>
                            </div>
                          </form>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* Rightbar contents end*/}
            </div>
          </div>
        </main>
        {/* main body ends */}

        {/* Multi Select Modal */}
        <ItemMultiSelectModalForItem
          show={showMultiSelectModal}
          onClose={() => setShowMultiSelectModal(false)}
          onAdd={handleAddMultipleItems}
          items={foodForPOS || []}
          title="Select Food Items"
          groupKey="food_group_name"
        />
      </>
    );
}

export default FgRequisitionAction;